import Scrollhistorie from '@nrk/dh-basis-scrollhistorie'
import { closest } from '@nrk/dh-basis-common'

/* styles */
import styles from './forklaringsscroll.module.css'
import './media/background.module.css'
import './cards/cards.module.css'
import './cards/alt-text.module.css'

export default class Forklaringsscroll extends Scrollhistorie {
  connectedCallback() {
    super.connectedCallback()
    requestAnimationFrame(this.updateMarginAndHeights)
    window.addEventListener('resize', this.updateMarginAndHeights)

    /* Scroll text into view when media-element receives focus */
    for (const elm of this.querySelectorAll('img, video, [role=img]')) {
      elm.tabIndex = '-1'
    }
    this.addEventListener('focus', this._handleFocus, true)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('resize', this.updateMarginAndHeights)
    this.removeEventListener('focus', this._handleFocus, true)
  }

  measureICBHeight() {
    if (window?.viewport?.segments?.[0]?.height) {
      return window.viewport.segments[0].height
    }
    // TODO: Remove once the viewport api is stable and supported in most browsers.

    /*
     * Measure the height of the Initial Containing Block (ICB).
     * In most modern browsers 100vh === height of the ICB.
     * The ICB does not change when the URL bar is hidden.
     * */
    try {
      const element = document.createElement('div')
      element.style.height = 'calc(100 * var(--dh-vh))'
      element.style.position = 'absolute'
      element.style.top = '0'
      element.style.left = '0'
      document.documentElement.appendChild(element)
      const icbHeight = element.offsetHeight
      document.documentElement.removeChild(element)
      return icbHeight
    } catch (e) {
      return window.innerHeight
    }
  }

  _handleFocus = (e) => {
    const backgroundElement = e.target && closest(e.target, '[data-background-id]')
    const altTextElement = e.target && closest(e.target, `.${styles.altText}`)
    let triggerElement
    if (backgroundElement) {
      const backgroundId = backgroundElement.getAttribute('data-background-id')
      if (this.activeBackgroundId !== backgroundId) {
        triggerElement = this.triggerElements.find(
          (elm) => elm.getAttribute('data-show-background') === backgroundId,
        )
      }
    } else if (altTextElement) {
      triggerElement = altTextElement.nextElementSibling
    }

    if (triggerElement && triggerElement.getAttribute('data-state') !== 'ACTIVE') {
      window.scrollTo(0, triggerElement.offsetTop - window.innerHeight / 2)
    }
  }

  updateMarginAndHeights = () => {
    const backgrounds = this.backgrounds
    if (!backgrounds || !backgrounds.length) {
      return
    }

    const icbHeight = this.measureICBHeight()
    // Measure first visible background. All backgrounds should be 3:4
    const background = backgrounds.find((b) => b.offsetHeight)
    if (!background) {
      return
    }
    const storyMargin = (icbHeight - background.offsetHeight) / 2

    if (!isNaN(storyMargin)) {
      const negativeStoryMargin = `${(-1 * storyMargin).toFixed(1)}px`
      this.rootMargin = `${negativeStoryMargin} 0px ${negativeStoryMargin} 0px`
    }
  }
}
